<template>
  <form-block
    v-if="facebookAttributionWindows.length !== 0"
    :title="tr('Attribution window')"
  >
    <ui-radio-group
      :model-value="isCustom ? 'custom' : 'default'"
      :disabled="disabled"
      class="flex flex-col gap-2.5"
      @update:model-value="(value) => isCustom = value === 'custom'"
    >
      <label class="flex w-fit cursor-pointer items-center gap-2 text-sm text-foreground">
        <ui-radio-group-item value="default" />
        {{ tr('Default') }}
      </label>
      <label class="flex w-fit cursor-pointer items-center gap-2 text-sm text-foreground">
        <ui-radio-group-item value="custom" />
        {{ tr('Custom') }}
      </label>
    </ui-radio-group>

    <div v-if="isCustom" class="flex flex-col gap-3 text-sm text-muted-foreground">
      <p class="m-0">
        {{ tr('The number of days between when a person viewed or clicked your ad and subsequently took an action.') }}
        <a href="https://www.facebook.com/business/help/2198119873776795?id=768381033531365" target="_blank">{{ tr('Learn more') }}</a>
      </p>
      <select-field
        v-model="entity.settings.adset_attribution_window"
        :options="facebookAttributionWindows"
        :reduce="(obj) => obj.machine_name"
        :aria-label="tr('Attribution window')"
        :disabled="disabled"
      />
      <p class="m-0">{{ tr('By default Ads Manager uses ad set attribution window, also known as unified attribution window. You may see discrepancies in conversion data if this setting is disabled.') }}</p>
    </div>
  </form-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import SelectField from '@/ui/components/SelectField.vue';

export default {
  name: 'AttributionWindowBlock',
  components: {
    SelectField,
  },
  mixins: [ RuleFormBlockMixin ],
  data: () => ({
    isCustom: null,
  }),
  computed: {
    facebookAttributionWindows() {
      const items = this.$store.getters['app/facebookAttributionWindows'];
      return this.filterSelectValuesByConditions(items);
    },
  },
  watch: {
    isCustomAttributionWindow(val, oldVal) {
      if (oldVal === null || val == oldVal) {
        return;
      }

      if (val) {
        this.entity.settings.adset_attribution_window = this.facebookAttributionWindows[0].machine_name;
      }
      else {
        this.entity.settings.adset_attribution_window = null;
      }
    },
  },
  created() {
    this.isCustom = !!this.entity.settings.adset_attribution_window;
  },
};
</script>
